import { add, round } from "@pentacode/openapi";
export function roundTimeBalance(balance) {
    return {
        ...balance,
        work: round(balance.work, 2),
        absences: round(balance.absences, 2),
        adjustments: round(balance.adjustments, 2),
        actual: round(balance.actual, 2),
        nominal: round(balance.nominal, 2),
        difference: round(balance.difference, 2),
        reset: typeof balance.reset === "number" ? round(balance.reset, 2) : undefined,
        carry: round(balance.carry ?? 0, 2),
        balance: round(balance.balance ?? 0, 2),
    };
}
export function roundVacationBalance(balance) {
    return {
        ...balance,
        taken: round(balance.taken, 2),
        adjustments: round(balance.adjustments, 2),
        actual: round(balance.actual, 2),
        nominal: round(balance.nominal, 2),
        difference: round(balance.difference, 2),
        reset: typeof balance.reset === "number" ? round(balance.reset, 2) : undefined,
        carry: round(balance.carry || 0, 2),
        balance: round(balance.balance || 0, 2),
    };
}
export function roundBonusesBalance(balance) {
    return {
        ...balance,
        taxed: round(balance.taxed, 2),
        untaxed: round(balance.untaxed, 2),
        actual: round(balance.actual, 2),
        nominal: typeof balance.nominal !== "undefined" ? round(balance.nominal, 2) : undefined,
        difference: typeof balance.difference !== "undefined" ? round(balance.difference, 2) : undefined,
        reset: typeof balance.reset === "number" ? round(balance.reset, 2) : undefined,
        carry: typeof balance.carry !== "undefined" ? round(balance.carry, 2) : undefined,
        balance: typeof balance.balance !== "undefined" ? round(balance.balance, 2) : undefined,
    };
}
export function addTimeBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: add(balanceA.carry, balanceB.carry),
        actual: add(balanceA.actual, balanceB.actual),
        nominal: add(balanceA.nominal, balanceB.nominal),
        difference: add(balanceA.difference, balanceB.difference),
        work: add(balanceA.work, balanceB.work),
        absences: add(balanceA.absences, balanceB.absences),
        adjustments: add(balanceA.adjustments, balanceB.adjustments),
        balance: add(balanceA.balance, balanceB.balance),
    };
}
export function addVacationBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: add(balanceA.carry, balanceB.carry),
        actual: add(balanceA.actual, balanceB.actual),
        nominal: add(balanceA.nominal, balanceB.nominal),
        difference: add(balanceA.difference, balanceB.difference),
        taken: add(balanceA.taken, balanceB.taken),
        adjustments: add(balanceA.adjustments, balanceB.adjustments),
        balance: add(balanceA.balance, balanceB.balance),
    };
}
export function addBonusesBalances(balanceA, balanceB) {
    return {
        ...balanceA,
        carry: typeof balanceA.carry === "number" && typeof balanceB.carry === "number"
            ? add(balanceA.carry, balanceB.carry)
            : (balanceA.carry ?? balanceB.carry),
        actual: add(balanceA.actual, balanceB.actual),
        nominal: typeof balanceA.nominal === "number" && typeof balanceB.nominal === "number"
            ? add(balanceA.nominal, balanceB.nominal)
            : (balanceA.nominal ?? balanceB.nominal),
        difference: typeof balanceA.difference === "number" && typeof balanceB.difference === "number"
            ? add(balanceA.difference, balanceB.difference)
            : (balanceA.difference ?? balanceB.difference),
        taxed: add(balanceA.taxed, balanceB.taxed),
        untaxed: add(balanceA.untaxed, balanceB.untaxed),
        balance: typeof balanceA.balance === "number" && typeof balanceB.balance === "number"
            ? add(balanceA.balance, balanceB.balance)
            : (balanceA.balance ?? balanceB.balance),
    };
}
export function makeEmptyTimeBalance({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        carry: 0,
        actual: 0,
        nominal: 0,
        difference: 0,
        work: 0,
        absences: 0,
        adjustments: 0,
        balance: 0,
    };
}
export function makeEmptyVacationBalance({ employeeId, from, to, }) {
    return {
        employeeId,
        from,
        to,
        carry: 0,
        actual: 0,
        nominal: 0,
        difference: 0,
        taken: 0,
        adjustments: 0,
        balance: 0,
    };
}
export function makeEmptyBonusesBalance({ employeeId, from, to }) {
    return {
        employeeId,
        from,
        to,
        actual: 0,
        taxed: 0,
        untaxed: 0,
    };
}
export function sumTimeBalances(balances) {
    if (!balances.length) {
        return makeEmptyTimeBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addTimeBalances(total, { ...each, carry: each.reset ?? each.carry }), makeEmptyTimeBalance(balances[0]));
}
export function sumVacationBalances(balances) {
    if (!balances.length) {
        return makeEmptyVacationBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addVacationBalances(total, { ...each, carry: each.reset ?? each.carry }), makeEmptyVacationBalance(balances[0]));
}
export function sumBonusesBalances(balances) {
    if (!balances.length) {
        return makeEmptyBonusesBalance({
            employeeId: 0,
            from: "1970-01-01",
            to: "1970-01-01",
        });
    }
    return balances.reduce((total, each) => addBonusesBalances(total, { ...each, carry: each.reset ?? each.carry }), makeEmptyBonusesBalance(balances[0]));
}
//# sourceMappingURL=balances.js.map